import pluralize from 'pluralize'

export const convertMonthToYear = (value: string) =>
    Math.round(Number(value) / 12).toString()

export const convertYearToMonth = (value: string) =>
    (Number(value) * 12).toString()

export const formatLoanTermYears = (loanTerm?: string | number): string => {
    if (!loanTerm) {
        return ''
    }

    const termInYears = convertMonthToYear(loanTerm.toString())

    return `${termInYears} ${pluralize('year', Number(termInYears))}`
}
